import { __awaiter } from "tslib";
import axios from 'axios';
class RebillyWrapper {
    constructor(organizationId, publishedKey, secretKey, sandbox) {
        this.secretKey = secretKey;
        this.publishedKey = publishedKey;
        this.organizationId = organizationId;
        this.sandbox = !!sandbox;
    }
    get apiDomain() {
        return this.sandbox ? RebillyWrapper.sandboxDomain : RebillyWrapper.apiDomain;
    }
    get headers() {
        var _a, _b, _c, _d;
        return {
            Authorization: (_b = (_a = this.secretKey) !== null && _a !== void 0 ? _a : this.publishedKey) !== null && _b !== void 0 ? _b : '',
            'Organization-Id': this.organizationId,
            'REB-APIKEY': (_d = (_c = this.secretKey) !== null && _c !== void 0 ? _c : this.publishedKey) !== null && _d !== void 0 ? _d : '',
        };
    }
    createPaymentToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.apiDomain}/tokens`, params, {
                headers: this.headers,
            })).data;
        });
    }
    createOrder(params) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return (yield axios.post(`${this.apiDomain}/subscriptions?expand=recentInvoice,initialInvoice`, params, {
                    headers: this.headers,
                })).data;
            }
            catch (ex) {
                const error = ex;
                console.log(`ERROR: ${JSON.stringify((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data)}`);
                throw ex;
            }
        });
    }
    createInvoice(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.apiDomain}/invoices`, params, {
                headers: this.headers,
            })).data;
        });
    }
    createTransaction(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.apiDomain}/transactions`, params, {
                headers: this.headers,
            })).data;
        });
    }
    createCustomer(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.apiDomain}/customers`, params, {
                headers: this.headers,
            })).data;
        });
    }
}
RebillyWrapper.sandboxDomain = 'https://api-sandbox.rebilly.com';
RebillyWrapper.apiDomain = 'https://api.rebilly.com';
export default RebillyWrapper;
//# sourceMappingURL=Wrapper.js.map